export default {"src":"https://webcdn.trailways.ca/_next/static/media/phone-primary.bb24de17.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};